<template>
  <router-view name="popup" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "PopUp",
};
</script>
